<ng-container *ngIf="tokenExit()">
  <div class="app-container" *ngIf="isAuthorized else elseBlock">
    <div class="app-container" *ngIf="!mobile" theme>
      <div class="app-body">
        <mat-drawer-container autosize>
          <mat-drawer mode="side" opened="true">
            <collapse-side-navigation
              [menuOpen]="isMenuOpened"
            ></collapse-side-navigation>
          </mat-drawer>
          <mat-drawer-content class="app-content">
            <app-header (toggleSidebarForMe)="sideBarToggler()"></app-header>
            <app-custom-alert class="alert-message"></app-custom-alert>
            <router-outlet></router-outlet>
          </mat-drawer-content>
        </mat-drawer-container>
      </div>
      <app-footer></app-footer>
    </div>    
    <div class="app-container" *ngIf="mobile" theme>
      <app-mobile-header></app-mobile-header>
      <app-custom-alert class="alert-message"></app-custom-alert>
      <div class="app-body">
        <app-mobile-sidenav
          [listMenu]="claimsMenu"
          [menuType]="'button'"
          (valueChange)="navigateToDetails($event)"
        ></app-mobile-sidenav>
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</ng-container>

<ng-template #elseBlock>
  <router-outlet></router-outlet>
</ng-template>